<template>
  <div class="interferencias">
    <nav>
      <div class="nav-left">
        <router-link to="/portfolio">Portfolio </router-link> 
        <span class="separador">&nbsp;</span>
        <router-link to="/atelier">Atelier </router-link> 
        <span class="separador">&nbsp;</span>
        <router-link to="/registos">Registos </router-link>
        <span class="separador">&nbsp;</span>
        <span class="current">Interferências</span>
      </div>
      <div class="nav-right">
        <router-link to="/contactos">Contactos</router-link>
      </div>
    </nav>

    <carousel class="interferencias-carousel" :perPage="1" :paginationEnabled="false" :navigationEnabled="true">
      <slide class="interferencias-slide" v-for="texto in textos" :key="texto.id">
      <div class="text">
          <div class="text-title" v-html="texto.titulo">
          </div>
          <div class="text-texto">
            <div class="text-texto-col" v-html="texto.col1"></div>
            <div class="text-texto-col" v-html="texto.col2"></div>
            <div class="text-texto-col" v-html="texto.col3"></div>
          </div>
      </div>
      </slide>
    </carousel>

  </div>
</template>

<script>

import { Carousel, Slide } from 'vue-carousel'
import axios from 'axios'
import VueAxios from 'vue-axios'

export default {
  name: 'Interferencias',
  data () {
    return {
      textos: [
      ]
    }
  },
  components: {
    Carousel,
    Slide
  },
  methods: {
    loadInterferencias: function () {
      var app = this
      axios.get('/admin/api/interferencias').then((response) => {
        app.textos = response.data
      })
    }
  },
  mounted: function () {
    this.loadInterferencias()
  }
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">

.interferencias {
  &-carousel {
    .VueCarousel-slide {
      height: calc(100vh - 100px);
    }
    .VueCarousel-dot-container {
      margin-top: -18px;
    }
  }
  &-title {
    background: black;
    color: white;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  &-slide {
      height: 100%;
      background: black;
      padding: 0px;
      display: flex;
    align-items: center;
  }
  .text {
    display: flex;
    align-items: flex-start;
    font-family: Georgia;
    margin: 0 auto;
    &-title {
      color: white;
      font-size: 22px;
      font-weight: 600;
      max-width: 220px;
      margin-right: 20px;
    }
    &-texto {
      font-size: 12px;
      color: white;
      display: flex;
      &-col {
        max-width: 220px;
        margin-right: 20px;
      }
      
    }
    p {
      margin: 0;
    }
  }
}

@media (min-width: 769px) and (max-width: 1000px) {

.interferencias {
  .text {
    &-title {
      width: 170px;
      margin: 0 8px;
      font-size: 20px;
    }
    &-texto {
      &-col {
        width: 190px;
        margin-right: 8px;
      }
    }
  }
}

}

@media (max-width: 768px) {

.interferencias {
    &-slide {
      background: white;
     align-items: baseline;
    }
  .text {
    flex-direction: column;
    
    
    &-title {
      color: black;
      width: 100%;
    }
    &-texto {
      color: black;
      display: block;
    }
  }
}

}




</style>
